/**
 * Gift Card Form — Interactive Preview + AJAX Cart Integration
 * Reads product variants from JSON, updates live preview, submits to Shopify AJAX Cart API.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-gift-card-form]');
  if (!root) return;

  /* ---- DOM References ---- */
  var previewAmount = root.querySelector('[data-preview-amount]');
  var previewName = root.querySelector('[data-preview-name]');
  var previewMessage = root.querySelector('[data-preview-message]');
  var previewCard = root.querySelector('[data-preview-card]');

  var amountBtns = root.querySelectorAll('[data-amount-btn]');
  var recipientNameInput = root.querySelector('[data-recipient-name]');
  var recipientEmailInput = root.querySelector('[data-recipient-email]');
  var senderNameInput = root.querySelector('[data-sender-name]');
  var messageInput = root.querySelector('[data-message-input]');
  var messageCounter = root.querySelector('[data-message-counter]');
  var designBtns = root.querySelectorAll('[data-design-btn]');
  var deliveryBtns = root.querySelectorAll('[data-delivery-btn]');
  var emailField = root.querySelector('[data-email-field]');
  var addToCartBtn = root.querySelector('.gift-card__add-btn');

  /* ---- Parse Variants ---- */
  var variantsEl = document.querySelector('[data-gift-card-variants]');
  var variants = [];
  if (variantsEl) {
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { /* ignore */ }
  }

  /* ---- State ---- */
  var initialVariant = variants.length > 1 ? variants[1] : variants[0];
  var state = {
    variantId: initialVariant ? initialVariant.id : null,
    amount: initialVariant ? (initialVariant.price / 100) : 50,
    recipientName: '',
    recipientEmail: '',
    senderName: '',
    message: '',
    design: 'rose',
    delivery: 'email'
  };

  /* ---- Design Gradients ---- */
  var gradients = {
    rose: 'linear-gradient(135deg, #b93b8a, #d965a8)',
    gold: 'linear-gradient(135deg, #C46A3C, #E8A87C)',
    green: 'linear-gradient(135deg, #059669, #34d399)'
  };

  /* ---- Update Preview ---- */
  function updatePreview() {
    if (previewAmount) {
      previewAmount.textContent = '\u20AC' + state.amount;
    }

    if (previewName) {
      previewName.textContent = state.recipientName || 'Nome destinatario';
      previewName.style.opacity = state.recipientName ? '1' : '0.6';
    }

    if (previewMessage) {
      if (state.message) {
        var text = '\u201C' + state.message + '\u201D';
        if (state.senderName) {
          text += ' \u2014 ' + state.senderName;
        }
        previewMessage.textContent = text;
        previewMessage.style.opacity = '1';
      } else {
        previewMessage.textContent = 'Il tuo messaggio apparir\u00E0 qui';
        previewMessage.style.opacity = '0.6';
      }
    }

    if (previewCard) {
      previewCard.style.background = gradients[state.design] || gradients.rose;
    }
  }

  /* ---- Amount Buttons (from product variants) ---- */
  amountBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.variantId = this.getAttribute('data-variant-id');
      state.amount = parseFloat(this.getAttribute('data-amount-btn')) || 50;

      amountBtns.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');

      updatePreview();
    });
  });

  /* ---- Recipient Name ---- */
  if (recipientNameInput) {
    recipientNameInput.addEventListener('input', function () {
      state.recipientName = this.value;
      updatePreview();
    });
  }

  /* ---- Sender Name ---- */
  if (senderNameInput) {
    senderNameInput.addEventListener('input', function () {
      state.senderName = this.value;
      updatePreview();
    });
  }

  /* ---- Message ---- */
  if (messageInput) {
    messageInput.addEventListener('input', function () {
      state.message = this.value;
      if (messageCounter) {
        messageCounter.textContent = this.value.length + '/200 caratteri';
      }
      updatePreview();
    });
  }

  /* ---- Design Selector ---- */
  designBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var design = this.getAttribute('data-design-btn');
      state.design = design;

      designBtns.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');

      updatePreview();
    });
  });

  /* ---- Delivery Toggle ---- */
  deliveryBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delivery = this.getAttribute('data-delivery-btn');
      state.delivery = delivery;

      deliveryBtns.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');

      if (emailField) {
        emailField.style.display = delivery === 'email' ? '' : 'none';
      }
    });
  });

  /* ---- Email sync ---- */
  if (recipientEmailInput) {
    recipientEmailInput.addEventListener('input', function () {
      state.recipientEmail = this.value;
    });
  }

  /* ---- Add to Cart (AJAX via TYShop.Cart) ---- */
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      if (!state.variantId) {
        if (window.TYShop && window.TYShop.Toast) {
          window.TYShop.Toast.error('Seleziona un importo');
        }
        return;
      }

      if (state.delivery === 'email' && !state.recipientEmail) {
        if (recipientEmailInput) recipientEmailInput.focus();
        if (window.TYShop && window.TYShop.Toast) {
          window.TYShop.Toast.error('Inserisci l\'email del destinatario');
        }
        return;
      }

      /* Build line item properties */
      var properties = {};
      if (state.recipientName) properties['Destinatario'] = state.recipientName;
      if (state.recipientEmail && state.delivery === 'email') properties['Email destinatario'] = state.recipientEmail;
      if (state.senderName) properties['Da'] = state.senderName;
      if (state.message) properties['Messaggio'] = state.message;
      properties['Design'] = state.design;
      properties['Consegna'] = state.delivery === 'email' ? 'Email' : 'Confezione regalo';

      /* Disable button during request */
      var btn = addToCartBtn;
      var origHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span class="gift-card__btn-spinner"></span> Aggiunta in corso...';

      if (window.TYShop && window.TYShop.Cart) {
        window.TYShop.Cart.add(state.variantId, 1, properties).then(function () {
          btn.disabled = false;
          btn.innerHTML = origHTML;
        });
      } else {
        btn.disabled = false;
        btn.innerHTML = origHTML;
      }
    });
  }

  /* ---- Init ---- */
  updatePreview();
})();
